import { motion } from "framer-motion";
import { useParams, Link } from "wouter";
import { useReservation } from "@/lib/api";
import { ReservationCard } from "../components/ReservationCard";
import { PageHeader } from "@/components/ux/PageHeader";
import { useEffect, useState } from "react";
import { Loader } from '@/components/Loader';

export default function BookingDetail() {
  const [refetchUntilActive, setRefetchUntilActive] = useState(false);
  const { bookingId } = useParams<{ bookingId: string }>();
  const { data: reservationData, isLoading, refetch } = useReservation(bookingId || null, {
    useBackoff: refetchUntilActive,
  });
  useEffect(() => {
    if (reservationData?.data?.status === "pending") {
      setRefetchUntilActive(true);
    } else {
      setRefetchUntilActive(false);
    }
  }, [reservationData?.data?.status]);

  const reservation = reservationData?.data;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center pt-16">
        <Loader />
      </div>
    );
  }

  if (!reservation) {
    return (
      <div className="pt-4 pb-24 md:pt-8 px-4">
        <div className="max-w-4xl mx-auto">
          <PageHeader backHref="/dashboard" backLabel="Back to Dashboard" />
          <div className="card text-center py-12">
            <h3 className="text-xl font-semibold mb-2">
              Booking not found
            </h3>
            <p className="text-dark-muted mb-6">
              The booking you're looking for doesn't exist or you don't have access to it.
            </p>
            <Link href="/dashboard" className="btn btn-primary">
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-4 pb-24 md:pt-8 px-4">
      <div className="max-w-4xl mx-auto">
        <PageHeader title="Your Booking" backHref="/dashboard" backLabel="Back to Dashboard" />

        {/* Reservation Card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <ReservationCard
            reservation={reservation}
            onCancelSuccess={refetch}
            clickable={false}
            allowAutoConfirm={true}
            expanded
          />
        </motion.div>

        {/* Additional Actions */}
        {reservation.status === "active" && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="mt-6 flex gap-4 flex-wrap"
          >
            <Link href="/booking" className="btn btn-primary">
              Book Another Event
            </Link>
          </motion.div>
        )}
      </div>
    </div>
  );
}

